if (!customElements.get('hp-dose-video')) {
  class HpDoseVideo extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video = this.querySelector('video');
      this.media = this.querySelector('.hp-dose-v2__media');
      this.inView = false;

      // Native details remain usable without JavaScript. Editor selection opens the selected block.
      this.addEventListener('shopify:block:select', (event) => {
        const item = [...this.querySelectorAll('[data-block-id]')].find(
          (element) => element.dataset.blockId === event.detail?.blockId
        );
        if (item) item.open = true;
      }, options);

      if (!this.video) return;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.controls = false;
      this.video.playsInline = true;
      this.video.disablePictureInPicture = true;
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('webkit-playsinline', '');
      this.media.addEventListener('contextmenu', (event) => event.preventDefault(), options);
      this.media.addEventListener('dragstart', (event) => event.preventDefault(), options);
      this.video.addEventListener('loadeddata', () => this.play(), options);
      this.video.addEventListener('canplay', () => this.play(), options);
      this.video.addEventListener('ended', () => this.play(), options);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.play();
      }, options);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // O vídeo nasce com preload="none" e sem autoplay: nenhum byte sai da rede
      // enquanto a section estiver longe da tela. Quem manda carregar é o observer.
      if (typeof IntersectionObserver !== 'function') {
        this.inView = true;
        this.play();
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.inView = entry.isIntersecting;
          if (this.inView) {
            this.play();
          } else if (this.video && !this.video.paused) {
            this.video.pause();
          }
        });
      }, { rootMargin: '400px 0px' });

      this.observer.observe(this);
    }

    play() {
      if (!this.isConnected || !this.video || document.hidden || !this.inView) return;
      // Respect browser autoplay restrictions; no retry timer or forced user gesture.
      this.video.play()?.catch(() => {});
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = null;
      this.observer = null;
    }
  }
  customElements.define('hp-dose-video', HpDoseVideo);
}
